import { useLayoutEffect } from 'react';
import {
  Channel,
  EventType,
  PageComponentType,
  useChannelContext,
  useEventBusEmit,
} from 'scbk-services';

/**
 * 페이지 완료 처리 HOC
 * @param Page
 * @returns
 */
export function withPageLoadCompleted<P extends {}>(
  Page: PageComponentType<P>,
): PageComponentType<P> {
  const Wrapped: React.FC<P> = (props: P) => {
    const { channel } = useChannelContext();
    const emit = useEventBusEmit();

    useLayoutEffect(() => {
      if (channel !== Channel.MB) {
        return;
      }

      emit(EventType.ScPageReady);
    }, [channel, emit]);

    return <Page {...props} />;
  };

  Wrapped.displayName = `withPageLoadCompleted(${Page.displayName || Page.name || 'Page'})`;
  return Wrapped;
}
